import React, { useEffect, useState } from "react";
import "../css/LoginPage.css";
import { useOktaAuth } from "@okta/okta-react";
import { signIn } from "@aws-amplify/auth";
import { Form, Input, message, Spin } from "antd";
import { useHistory } from "react-router-dom";
import CarrierLogo from "../assets/CarrierLogo";
import { getCognitoToken } from "../fetchToken";
import { validateFields } from "../utils/validateFields";

const LoginPage = ({ disabledOnLoad = false }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const showToast = ({ success, message: msg }) => {
    success ? message.success(msg, 3) : message.error(msg, 3);
  };
  const { validationSuccess, validationMessage } = validateFields(email, password);
  const [isOktaLoading, setIsOktaLoading] = useState(false);
  const [isCognitoLoading, setIsCognitoLoading] = useState(false);
  const { oktaAuth } = useOktaAuth();
  const history = useHistory();
  const isNotEmptyInput = !email.trim() || !password.trim()
  const isButtonLoading = isOktaLoading || isCognitoLoading;

  useEffect(() => {
    if (disabledOnLoad) {
      document.body.style.backgroundImage = "none";
    }

    return () => {
      document.body.style.backgroundImage = "";
    };
  }, [disabledOnLoad]);
  

  const handleLoginForOkta = async () => {
    setIsOktaLoading(true);
    try {
      localStorage.setItem("loggedInAs", "okta");
      await oktaAuth.signInWithRedirect({ originalUri: "/home" });
    } catch (error) {
      console.log(error);
      setIsOktaLoading(false);
      showToast({ success: false, message: error.message });
    }
  };

  const handleLoginForCognito = async () => {
    if (!validationSuccess) {
      showToast({ success: false, message: validationMessage });
      return;
    }
    try {
      setIsCognitoLoading(true);
      await signIn({
        username: email.trim(),
        password: password.trim(),
      });
      const { accessToken } = await getCognitoToken();
      setIsCognitoLoading(false);
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("loggedInAs", "cognito");
      history.push("/home");
    } catch (error) {
      setIsCognitoLoading(false);
      console.log(error);
      showToast({ success: false, message: error.message });
    }
  };

  if (disabledOnLoad) {
    return (
      <div className="container">
        <div className="main">
          <Spin size="large" />
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="main">
        <div className="login-wrapper">
          <div className="info-panel">
            <div className="logo-container w-75">
              <CarrierLogo />
            </div>
            <h3>Access Guidelines</h3>
            <div className="info-section">
              <h4>1. Login with OKTA if you want to:</h4>
              <ul>
                <li>Manage Feature Flags</li>
                <li>View Provisioning Status</li>
              </ul>
            </div>
            <div className="info-section">
              <h4>2. Login with Cognito if you want to:</h4>
              <ul>
                <li>Update MAC and PIN</li>
                <li>Provision the B-type wall controller</li>
              </ul>
            </div>
          </div>

          <hr className="vertical-divider" />

          <div className="login-card">
            <h2>Select Feature Access</h2>
            <p>Choose how you want duly to login:</p>
            <div className="btn-group">
              <button
                className="login-btn primary"
                onClick={handleLoginForOkta}
                disabled={isButtonLoading}
              >
                {isOktaLoading ? (
                  <div className="spinner"></div>
                ) : (
                  "Login with OKTA"
                )}
              </button>

              <h4>Or</h4>

              <Form validateTrigger="onSubmit">
                <Input
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email or Username"
                  style={{ marginBottom: "7%", padding: "4%" }}
                  disabled={isButtonLoading}
                  rules={[
                    { required: true, message: "Please enter your email" },
                  ]}
                />
                <Input
                  type="password"
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  style={{ marginBottom: "7%", padding: "4%" }}
                  disabled={isButtonLoading}
                  rules={[
                    { required: true, message: "Please enter your email" },
                  ]}
                />
                <button
                  type="button"
                  className={`login-btn secondary ${isNotEmptyInput ? "disabled" : ""}`}
                  onClick={handleLoginForCognito}
                  disabled={isButtonLoading||isNotEmptyInput}
                >
                  {isCognitoLoading ? (
                    <div className="spinner"></div>
                  ) : (
                    "Login with Cognito"
                  )}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
